import { has, isNil, isEmpty } from "ramda";
import { Terminal } from "./types";
import { ApplicationState } from "../index";

export function getErrors(terminal: Terminal | null) {
  return !isNil(terminal) &&
    has("errors", terminal) &&
    !isEmpty(terminal.errors)
    ? terminal.errors
    : null;
}

export function getById(id: string) {
  return (state: ApplicationState) =>
    state.terminal.data?.data?.find((x) => x.id === id);
}
